import React, { useEffect, useRef } from 'react';
import {
  Animated,
  Dimensions,
  KeyboardAvoidingView,
  Modal,
  Platform,
  Pressable,
  StyleSheet,
  View,
} from 'react-native';

const SLIDE_START = Math.ceil(Dimensions.get('window').height * 0.45);

type Props = {
  visible: boolean;
  onRequestClose: () => void;
  children: React.ReactNode;
  /** Form modalları için true (varsayılan) */
  keyboardAvoiding?: boolean;
  /** true iken arka plan dokunuşu kapanış tetiklemez */
  dismissDisabled?: boolean;
};

/**
 * Şeffaf arka plan anında (animationType none); yalnızca alt levha hafif slide ile gelir.
 * iOS’ta slide animasyonunun karartmayla birlikte kayması sorununu giderir.
 */
export function ModalBottomSheet({
  visible,
  onRequestClose,
  children,
  keyboardAvoiding = true,
  dismissDisabled = false,
}: Props) {
  const translateY = useRef(new Animated.Value(SLIDE_START)).current;

  useEffect(() => {
    if (visible) {
      translateY.setValue(SLIDE_START);
      Animated.spring(translateY, {
        toValue: 0,
        useNativeDriver: true,
        friction: 12,
        tension: 68,
      }).start();
    } else {
      translateY.stopAnimation();
      translateY.setValue(SLIDE_START);
    }
  }, [visible, translateY]);

  return (
    <Modal visible={visible} transparent animationType="none" onRequestClose={onRequestClose}>
      <View style={styles.root}>
        <Pressable
          style={StyleSheet.absoluteFill}
          className="bg-black/40"
          onPress={dismissDisabled ? undefined : onRequestClose}
          accessibilityLabel="Kapat"
        />
        {keyboardAvoiding ? (
          <KeyboardAvoidingView
            behavior={Platform.OS === 'ios' ? 'padding' : undefined}
            style={styles.mount}
            pointerEvents="box-none">
            <Animated.View style={[styles.sheet, { transform: [{ translateY }] }]}>{children}</Animated.View>
          </KeyboardAvoidingView>
        ) : (
          <View style={styles.mount} pointerEvents="box-none">
            <Animated.View style={[styles.sheet, { transform: [{ translateY }] }]}>{children}</Animated.View>
          </View>
        )}
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  root: { flex: 1 },
  mount: { flex: 1, justifyContent: 'flex-end' },
  sheet: { width: '100%' },
});
